export const scrollPageToTop = () => {
  const pageElement = document.querySelector('body > .page');
  if (pageElement) {
    pageElement.scrollTop = 0;
  }
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};
export const smoothScrollToTop = () => {
  const pageElement = document.querySelector('body > .page');
  if (pageElement) {
    pageElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};